import Aside from "./Aside";

import './assets/aside.scss';

export default Aside;